import { Aks2talOnly } from 'components/AdminOnly';
import LevelHistory from '../LevelSensor/FlowConfigHistory';
import PlantHistory from '../PlantModule/FlowConfigHistory';

export default function FlowInternalHistory({
  configId,
  variant,
}: {
  configId: string;
  variant: 'level' | 'plant';
}) {
  return (
    <Aks2talOnly>
      {variant === 'level' ? (
        <LevelHistory configId={configId} />
      ) : (
        <PlantHistory configId={configId} />
      )}
    </Aks2talOnly>
  );
}
